/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Empty_TitleInputs */

const en_notes_v2_empty_title = /** @type {(inputs: Notes_V2_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes yet`)
};

const es_notes_v2_empty_title = /** @type {(inputs: Notes_V2_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay notas`)
};

/**
* | output |
* | --- |
* | "No notes yet" |
*
* @param {Notes_V2_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_empty_title = /** @type {((inputs?: Notes_V2_Empty_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Empty_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_empty_title(inputs)
	return en_notes_v2_empty_title(inputs)
});